/**
 * Brand icons shipped as static assets in `public/social media icons/`.
 *
 * Keeping the mapping in one place lets every platform icon renderer (Social Inbox,
 * Content Studio, Integrations) use the same artwork while unknown/unsupported
 * platforms keep falling back to their existing vector icon.
 */
export const SOCIAL_PLATFORM_ICON_DIR = `${String(import.meta.env.BASE_URL || "/").replace(
  /\/+$/,
  "",
)}/social%20media%20icons`;

export const SOCIAL_PLATFORM_ICON_SRC: Record<string, string> = {
  facebook: `${SOCIAL_PLATFORM_ICON_DIR}/facebook.png`,
  instagram: `${SOCIAL_PLATFORM_ICON_DIR}/instagram.png`,
  linkedin: `${SOCIAL_PLATFORM_ICON_DIR}/linkedin.png`,
  linkedin_company: `${SOCIAL_PLATFORM_ICON_DIR}/linkedin.png`,
  linkedin_personal: `${SOCIAL_PLATFORM_ICON_DIR}/linkedin.png`,
  linkedin_ads: `${SOCIAL_PLATFORM_ICON_DIR}/linkedin.png`,
  youtube: `${SOCIAL_PLATFORM_ICON_DIR}/youtube.png`,
  threads: `${SOCIAL_PLATFORM_ICON_DIR}/threads.png`,
  twitter: `${SOCIAL_PLATFORM_ICON_DIR}/twitter.png`,
  twitter_x: `${SOCIAL_PLATFORM_ICON_DIR}/twitter.png`,
  x: `${SOCIAL_PLATFORM_ICON_DIR}/twitter.png`,
};

/** Resolve a platform/provider id to its shipped brand icon (or `undefined`). */
export function socialPlatformIconSrc(id: string | null | undefined): string | undefined {
  const key = String(id || "")
    .trim()
    .toLowerCase();
  return key ? SOCIAL_PLATFORM_ICON_SRC[key] : undefined;
}

/** Shared `<img>` props for brand icons (decorative, non-draggable, lazily loaded). */
export const SOCIAL_PLATFORM_ICON_IMG_PROPS = {
  alt: "",
  "aria-hidden": true,
  loading: "lazy",
  decoding: "async",
  draggable: false,
} as const;
